import type { FC } from 'react';
import type { IMerchantLogoProps } from '../../ShipmentLogo';
import { DefaultLogoWithoutLetter, MerchantDefaultLogo, MerchantLogoWithLogo } from '../CommonLogos';

export const MerchantLogo: FC<Omit<IMerchantLogoProps, 'variant'>> = ({
  merchantLogo,
  merchantName,
  size = 'small',
}) => {
  if (merchantLogo) return <MerchantLogoWithLogo logo={merchantLogo} merchantName={merchantName} size={size} />;
  if (merchantName) return <MerchantDefaultLogo merchantName={merchantName} size={size} />;
  return <DefaultLogoWithoutLetter size={size} />;
};
